// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"Breadcrumbs_listContainer__BoiEk","dot":"Breadcrumbs_dot__vPMNe","dots":"Breadcrumbs_dots__f5PKS"};